
<div class="klk_toast" v-show="visible">
  <div class="toast_inner">
    <i :class="icon" class="icon"></i>
    <div class="title">{{ title }}</div>
  </div>
</div>
